//--------------------------------------------------------------
// Event Viewer Modal
//--------------------------------------------------------------
export const EVENT_MATCHES_EDIT_MODAL_SHOW = 'EVENT_MATCHES_EDIT_MODAL_SHOW';
export const EVENT_MATCHES_EDIT_MODAL_HIDE = 'EVENT_MATCHES_EDIT_MODAL_HIDE';

//--------------------------------------------------------------
// Device management
//--------------------------------------------------------------
export const DEVICE_TABLE_UPDATE_GROUPING = 'DEVICE_TABLE_UPDATE_GROUPING';
